import { createAction } from 'redux-act';
import { paramsForServer } from 'feathers-hooks-common';
//
import { ContentTagService } from 'services';
import { showErrorNotification } from 'utils/error-handlers';
import { deepMapTree } from 'utils/tree';
import {
  FETCH_CONTENT_TAG_TREE,
  CREATE_CONTENT_TAG,
  EDIT_CONTENT_TAG,
} from 'meeopp-graphql/modules/content-tags';
import { apolloClient } from 'meeopp-graphql/apollo-client';

export const setContentTags = createAction('setContentTags');
export const setContentTagTree = createAction('setContentTagTree');
export const setGlobalCurriculumTree = createAction('setGlobalCurriculumTree');
export const setGlobalMeeoppTopicTree = createAction('setGlobalMeeoppTopicTree');

const DEFAULT_CONTENT_TAG_TREE = Object.freeze({
  allNodes: [],
  topLevelNodes: [],
  globalNodes: {
    curriculums: [],
    meeoppTopics: [],
  },
});

export const fetchContentTags = (opts = {}) => {
  const { forceRefresh } = opts;
  return async (dispatch) => {
    try {
      const { allNodes, topLevelNodes, globalNodes } =
        (
          await apolloClient.query({
            query: FETCH_CONTENT_TAG_TREE,
            fetchPolicy: forceRefresh ? 'network-only' : 'cache-first',
          })
        )?.data?.contentTagTree ?? DEFAULT_CONTENT_TAG_TREE;

      dispatch(setContentTags(allNodes));
      dispatch(setContentTagTree(deepMapTree(topLevelNodes)));
      dispatch(setGlobalCurriculumTree(deepMapTree(globalNodes.curriculums)));
      dispatch(setGlobalMeeoppTopicTree(deepMapTree(globalNodes.meeoppTopics)));
    } catch (e) {
      showErrorNotification('Unable to fetch content tags');
    }
  };
};

export const createContentTag = (values) => {
  // Try catching outside
  return async (dispatch) => {
    await apolloClient.mutate({
      mutation: CREATE_CONTENT_TAG,
      variables: values,
    });

    dispatch(fetchContentTags({ forceRefresh: true }));
  };
};

export const patchContentTag = (tagId, values) => {
  return async (dispatch) => {
    await apolloClient.mutate({
      mutation: EDIT_CONTENT_TAG,
      variables: {
        contentTagId: tagId,
        ...values,
      },
    });

    dispatch(fetchContentTags({ forceRefresh: true }));
  };
};

export const patchContentTags = (filter, values) => {
  return async (dispatch) => {
    const { allNodes, topLevelNodes } = await ContentTagService.patch(
      null,
      values,
      paramsForServer({
        action: 'get-full-tree',
        query: filter,
      })
    );

    dispatch(setContentTags(allNodes));
    dispatch(setContentTagTree(deepMapTree(topLevelNodes)));
  };
};
